export function animationFunc(duration: any) {
  interface Animation {
    delay: number
    duration: number
    enabled: boolean
    name: string
    type: 'enter' | 'exit' | string
    data: Record<string, any>
  }

  const randomNumber = Math.random()
  const randomBinary = Math.round(randomNumber) // 0 or 1
  const nameArr = ['zoom', 'move'] // Move
  const randomNumberDirection = Math.floor(Math.random() * 6)
  const directionArr = ['up', 'down', 'top-right', 'top-left', 'bottom-right', 'bottom-left']
  const animations: Animation[] = [
    {
      delay: 0.01,
      duration: duration,
      enabled: true,
      name: nameArr[randomBinary],
      type: 'enter',
      data: {
        direction: nameArr[randomBinary] === 'move' ? directionArr[randomNumberDirection] : '',
      },
    },
    {
      delay: 0,
      duration: duration,
      enabled: false,
      name: nameArr[randomBinary],
      type: 'exit',
      data: {},
    },
  ]
  return animations
}
export function animationFuncMoveZoom(animtionType:string,duration: any) {
  
  interface Animation {
    delay: number
    duration: number
    enabled: boolean
    name: string
    type: 'enter' | 'exit' | string
    data: Record<string, any>
  }

  const randomNumber = Math.random()
  const randomBinary = Math.round(randomNumber) // 0 or 1
  const nameArr = [animtionType] // Move
  const randomNumberDirection = Math.floor(Math.random() * 6)
  const directionArr = ['up', 'down', 'top-right', 'top-left', 'bottom-right', 'bottom-left']
  const animations: Animation[] = [
    {
      delay: 0.01,
      duration: duration,
      enabled: true,
      name: nameArr[randomBinary],
      type: 'enter',
      data: {
        direction: nameArr[randomBinary] === 'move' ? directionArr[randomNumberDirection] : '',
      },
    },
    {
      delay: 0,
      duration: duration,
      enabled: false,
      name: nameArr[randomBinary],
      type: 'exit',
      data: {},
    },
  ]
  return animations
}
export function animationFuncCustomeOne3D(duration: any) {
  interface Animation {
    delay: number
    duration: number
    enabled: boolean
    name: string
    type: 'enter' | 'exit' | string
    data: Record<string, any>
  }

  const randomNumber = Math.random()
  const randomBinary = Math.round(randomNumber) // 0 or 1
  const nameArr = ['zoom', 'move'] // Move
  const randomNumberDirection = Math.floor(Math.random())
  // const directionArr = ['move-zoom', 'zoomIn-out']
  const directionArr = ['3d-perspective', '3d-perspective']
  const animations: Animation[] = [
    {
      delay: 0.01,
      duration: duration,
      enabled: true,
      name: 'move',
      type: 'enter',
      data: {
        direction:directionArr[randomNumberDirection],
        // direction:'zoomIn-out'
      },
    },
    {
      delay: 0,
      duration: duration,
      enabled: false,
      name: 'move',
      type: 'exit',
      data: {},
    },

    // {
    //   delay: 0.01,
    //   duration: 200,
    //   enabled: true,
    //   name: 'move',
    //   type: 'enter',
    //   data: {
    //     direction:'top-left',
    //   },
    // },
    // {
    //   delay: 0,
    //   duration: 200,
    //   enabled: false,
    //   name: 'move',
    //   type: 'exit',
    //   data: {},
    // },
    // {
    //   delay: 0.01,
    //   duration: 400,
    //   enabled: true,
    //   name: 'zoom',
    //   type: 'enter',
    //   data: {
    //     direction:'up',
    //   },
    // },
    // {
    //   delay: 0,
    //   duration: 200,
    //   enabled: false,
    //   name: 'zoom',
    //   type: 'exit',
    //   data: {},
    // },
   
  ]
  return animations
}

export function animationFuncCustomeOne(duration: any) {
  interface Animation {
    delay: number
    duration: number
    enabled: boolean
    name: string
    type: 'enter' | 'exit' | string
    data: Record<string, any>
  }

  const randomNumber = Math.random()
  const randomBinary = Math.round(randomNumber) // 0 or 1
  const nameArr = ['zoom', 'move'] // Move
  const randomNumberDirection = Math.floor(Math.random())
  const directionArr = ['move-zoom', 'zoomIn-out']
  // const directionArr = ['3d-perspective', '3d-perspective']
  const animations: Animation[] = [
    {
      delay: 0.01,
      duration: duration,
      enabled: true,
      name: 'move',
      type: 'enter',
      data: {
        direction:directionArr[randomNumberDirection],
        // direction:'zoomIn-out'
      },
    },
    {
      delay: 0,
      duration: duration,
      enabled: false,
      name: 'move',
      type: 'exit',
      data: {},
    },

    // {
    //   delay: 0.01,
    //   duration: 200,
    //   enabled: true,
    //   name: 'move',
    //   type: 'enter',
    //   data: {
    //     direction:'top-left',
    //   },
    // },
    // {
    //   delay: 0,
    //   duration: 200,
    //   enabled: false,
    //   name: 'move',
    //   type: 'exit',
    //   data: {},
    // },
    // {
    //   delay: 0.01,
    //   duration: 400,
    //   enabled: true,
    //   name: 'zoom',
    //   type: 'enter',
    //   data: {
    //     direction:'up',
    //   },
    // },
    // {
    //   delay: 0,
    //   duration: 200,
    //   enabled: false,
    //   name: 'zoom',
    //   type: 'exit',
    //   data: {},
    // },
   
  ]
  return animations
}


export function animationFuncCustomeOneZoomOutMove(animationType:any,duration: any) {
  interface Animation {
    delay: number
    duration: number
    enabled: boolean
    name: string
    type: 'enter' | 'exit' | string
    data: Record<string, any>
  }

  const randomNumber = Math.random()
  const randomBinary = Math.round(randomNumber) // 0 or 1
  const nameArr = ['zoom', 'move'] // Move
  const randomNumberDirection = Math.floor(Math.random())
  const directionArr = [animationType]
  // const directionArr = ['3d-perspective', '3d-perspective']
  const animations: Animation[] = [
    {
      delay: 0.01,
      duration: duration,
      enabled: true,
      name: 'move',
      type: 'enter',
      data: {
        direction:directionArr[randomNumberDirection],
        // direction:'zoomIn-out'
      },
    },
    {
      delay: 0,
      duration: duration,
      enabled: false,
      name: 'move',
      type: 'exit',
      data: {},
    },

    // {
    //   delay: 0.01,
    //   duration: 200,
    //   enabled: true,
    //   name: 'move',
    //   type: 'enter',
    //   data: {
    //     direction:'top-left',
    //   },
    // },
    // {
    //   delay: 0,
    //   duration: 200,
    //   enabled: false,
    //   name: 'move',
    //   type: 'exit',
    //   data: {},
    // },
    // {
    //   delay: 0.01,
    //   duration: 400,
    //   enabled: true,
    //   name: 'zoom',
    //   type: 'enter',
    //   data: {
    //     direction:'up',
    //   },
    // },
    // {
    //   delay: 0,
    //   duration: 200,
    //   enabled: false,
    //   name: 'zoom',
    //   type: 'exit',
    //   data: {},
    // },
   
  ]
  return animations
}

export function animationFuncCustomWiggle(animationType:any,duration: any) {
  interface Animation {
    delay: number
    duration: number
    enabled: boolean
    name: string
    type: 'enter' | 'exit' | string
    data: Record<string, any>
  }

  const randomNumber = Math.random()

  const randomNumberDirection = Math.floor(Math.random())
  const directionArr = [animationType]
 
  const animations: Animation[] = [
    {
      delay: 0.01,
      duration: duration,
      enabled: true,
      name: 'move',
      type: 'enter',
      data: {
        direction:directionArr[randomNumberDirection],
        // direction:'zoomIn-out'
      },
    },
    {
      delay: 0,
      duration: duration,
      enabled: false,
      name: 'move',
      type: 'exit',
      data: {},
    },

   
  ]
  return animations
}
export const animationList = [
  {
    value: 'no-effect',
    name: 'No Effect'
  },
  {
    value: 'move-zoom',
    name: 'Bounce & Zoom'
  },
  {
    value: 'zoomIn-out',
    name: 'Zoom In & Out'
  },
  {
    value: 'zoom',
    name: 'Simple Zoom'
  },
  {
    value: 'move',
    name: 'Simple Move'
  },
  {
    value: '3d-perspective',
    name: '3D Motion'
  },
  {
    value: 'Wiggle',
    name: 'Wiggle'
  },
  {
    value: 'ken-burns',
    name: 'Ken Burns'
  },
  {
    value: 'typing',
    name: 'Text Typing'
  }
];

// Ken Burns effect animation function - slowly zooms and pans across the image
export const animationFuncKenBurns = (pageDuration: any) => {
  // Default direction is random, can also be 'in' or 'out'
  const zoomDirection = Math.random() > 0.5 ? 'in' : 'out';
  
  // Generate random pan direction
  const panDirections = ['top-left', 'top-right', 'bottom-left', 'bottom-right', 'left', 'right', 'up', 'down'];
  const randomPanDirection = panDirections[Math.floor(Math.random() * panDirections.length)];
  
  return [
    {
      delay: 0,
      duration: pageDuration,
      enabled: true,
      type: 'enter',
      name: 'move',
      data: {
        direction: 'ken-burns',
        zoomDirection: zoomDirection,
        panDirection: randomPanDirection
      },
    },
    {
      delay: 0,
      duration: 0,
      enabled: false,
      type: 'exit',
      name: 'fade',
      data: {},
    },
  ];
};

// Text typing animation effect - creates a cinematic typing effect for text
export const animationFuncTyping = (pageDuration: any) => {
  return [
    {
      delay: 0,
      duration: pageDuration,
      enabled: true,
      type: 'enter',
      name: 'move',
      data: {
        direction: 'typing',
        speed: 'normal', // can be 'slow', 'normal', 'fast'
        showCursor: true
      }
    },
    {
      delay: 0,
      duration: 0,
      enabled: false,
      type: 'exit',
      name: 'fade',
      data: {}
    }
  ];
};
